import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import CreatingExecutorModal from "components/Deployments/CreatingExecutorModal";

import * as deploymentsReducer from "containers/Deployments/reducer";
import * as globalReducer from "containers/App/reducer";

class CreatingExecutorModalContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <CreatingExecutorModal {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  return {
    isCreatingExecutor: globalReducer.getIsCreatingExecutor(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(CreatingExecutorModalContainer);
